// src/lib/tenant.js
// Configuração do condomínio em tempo de execução (spec onboarding-tenant, RF-07): o mesmo build
// atende todos os condomínios; nome, status e flags vêm de GET /api/public/tenants/{codigo}.

import { TENANT_ID, API_CONDOMINIO_BASE_URL, FEATURES, FEATURE_OVERRIDES } from './config';
import { logger } from './logger/index';

const TEMPO_MAXIMO_MS = 5000;

/**
 * Carrega a configuração pública do tenant e aplica as flags em `features` (mutando o objeto,
 * que é o FEATURES exportado por config.js), exceto as definidas por variável de ambiente.
 * Falha de rede ou da API não bloqueia o app: segue com as flags locais.
 *
 * @returns {Promise<{ codigo: string, nome: string | null,
 *   status: 'Ativo' | 'Suspenso' | 'NaoEncontrado' | 'Indisponivel' }>}
 */
export async function carregarTenant({
  codigo = TENANT_ID,
  baseUrl = API_CONDOMINIO_BASE_URL,
  features = FEATURES,
  overrides = FEATURE_OVERRIDES,
  fetchImpl = globalThis.fetch,
} = {}) {
  const url = `${baseUrl}/public/tenants/${encodeURIComponent(codigo)}`;
  try {
    const response = await fetchImpl(url, { signal: AbortSignal.timeout(TEMPO_MAXIMO_MS) });

    if (response.status === 404) {
      logger.warn('Condomínio não encontrado no cadastro', { codigo });
      return { codigo, nome: null, status: 'NaoEncontrado' };
    }
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const dados = await response.json();
    for (const [flag, valor] of Object.entries(dados.features || {})) {
      if (flag in features && !(flag in overrides)) features[flag] = valor === true;
    }
    return { codigo, nome: dados.nome ?? null, status: dados.status };
  } catch (err) {
    logger.warn('Configuração do condomínio indisponível; usando as flags locais', { codigo, erro: err?.message });
    return { codigo, nome: null, status: 'Indisponivel' };
  }
}
